import { GradingSchema } from '../types';

export enum GradingSchemaActionType {
    GET_GRADING_SCHEMAS = 'GET_GRADING_SCHEMAS',
    CREATE_GRADING_SCHEMA = 'CREATE_GRADING_SCHEMA',
    UPDATE_GRADING_SCHEMA = 'UPDATE_GRADING_SCHEMA',
    DELETE_GRADING_SCHEMA = 'DELETE_GRADING_SCHEMA',
}

interface GetGradingSchemasAction {
    type: GradingSchemaActionType.GET_GRADING_SCHEMAS;
    payload: Array<GradingSchema>;
}

interface CreateGradingSchemaAction {
    type: GradingSchemaActionType.CREATE_GRADING_SCHEMA;
    payload: GradingSchema;
}

interface UpdateGradingSchemaAction {
    type: GradingSchemaActionType.UPDATE_GRADING_SCHEMA;
    payload: GradingSchema;
}

interface DeleteGradingSchemaAction {
    type: GradingSchemaActionType.DELETE_GRADING_SCHEMA;
    payload: GradingSchema;
}

export type GradingSchemaAction =
    | GetGradingSchemasAction
    | CreateGradingSchemaAction
    | UpdateGradingSchemaAction
    | DeleteGradingSchemaAction;
